// extracted by mini-css-extract-plugin
export default {"section_wrapper":"Work_section_wrapper__Jm+M7","folio_card":"Work_folio_card__Un0O9","folio_title_descr":"Work_folio_title_descr__37lej"};